import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconHomeStyle0 = cosmosIconCss;

const CosmosIconHome$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHome extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'bafdd5d663c22d062b405cadfc9ace5e868750f1', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '529fb46f64aa2f01aa401598616f89b5049b5406', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '15497ce85880dc01e71a2dde76887d4ce9c82975', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.671 9.767 11.333 3.13a.494.494 0 0 0-.666 0L3.329 9.767a1 1 0 0 0-.329.741v6.986a.508.508 0 0 0 .506.506H9a.5.5 0 0 0 .5-.5v-5h3v5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-6.992a1 1 0 0 0-.329-.74ZM17.55 16.55H14V11.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v5.05H4.45v-5.842L11 4.782l6.55 5.926v5.842Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconHomeStyle0; }
}, [1, "cosmos-icon-home", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-home"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-home":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHome$1);
            }
            break;
    } });
}

const CosmosIconHome = CosmosIconHome$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHome, defineCustomElement };
